import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Row, Workbook as wb, Worksheet} from "exceljs";
import {HorasExtrasTurnosService} from "../../services/horas-extra-turnos.service";
import {ModificacionMarcionesService} from "../../services/modificacion-marcaciones.service";
import {VerificacionTalentoHumanoService} from "../../services/verificacion-talento-humano.service";
import {UtilsService} from "../../../../shared/utils/utils.service";
import {DecimalPipe} from "@angular/common";
import {saveAs} from 'file-saver';
import {
  LfsaBotonEditarGridComponent
} from "../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component";
import {moduloHorasExtras} from "../../diccionarios/horas-extrasModulo";
import {Subscription} from "rxjs";

@Component({
  selector: 'app-verificacion-talento-humano-segunda-validacion',
  templateUrl: './verificacion-talento-humano-segunda-validacion.component.html',
  styleUrls: ['./verificacion-talento-humano-segunda-validacion.component.css']
})
export class VerificacionTalentoHumanoSegundaValidacionComponent implements OnInit {


  mostrarFormulario: boolean = false;
  mostrarGridLista: boolean = true;
  titulo: string;
  DAT_TITULOS: any;
  DAT_BTNCSS: any;
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formulario: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  frameworkComponents: any;
  columnDefs: any[];
  rowData: any[];
  reportData: any[];
  rowSelection: any;
  gridApi: any;
  gridColumnApi: any;
  obligatorylocality: boolean = false;
  today: any;
  cmbYears: any[] = [];
  cmbWeeks: any[] = [];

  workbook: wb;
  data: any = [];
  dataExcel: any = [];
  uploadForm: FormGroup;
  actualWeek: number;
  subscription1$: Subscription;

  @ViewChild('fileInput') fileInput: ElementRef;


  constructor(
    private fb: FormBuilder,
    private _horasExtrasTurnos: HorasExtrasTurnosService,
    private _modificacionMarcaciones: ModificacionMarcionesService,
    private _verificacionTalentoHumanoService: VerificacionTalentoHumanoService,
    private _util: UtilsService,
    private numberFormatter: DecimalPipe
  ) {
    this.diccionarioModulo = moduloHorasExtras;
  }

  ngOnInit(): void {
    this.DAT_BTNS = moduloHorasExtras.button.buttonsNombre;
    this.DAT_TITULOS = moduloHorasExtras.titulos.horasExtrasVerificacionTalentoHumanoSegundaVerificacion;
    this.DAT_BTNCSS = moduloHorasExtras.button.buttonsCss;
    this.DAT_MSG = moduloHorasExtras.mensajes;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.calculateCombos();
    this.formulario = this.fb.group({
      year: ['', [Validators.required]],
      week: ['', [Validators.required]],
      department: [''],
      id: ['', []],
      startDate: ['', []],
      endDate: ['', []],
    });
    this.girdComponent();
    this.selectCurrentDate();
  }

  formatoHorasNumeroToHorasFecha(data): string {
    const horas = Math.trunc(data);
    const minutosDecimal = (data - Math.trunc(data)) * 60;
    const onlyMinutos = Math.trunc(minutosDecimal);
    const segundosDecimal = (minutosDecimal - Math.trunc(minutosDecimal)) * 60;
    const onlySegundos = Math.trunc(segundosDecimal);
    const newFormatData = (horas < 10 ? '0' + horas : horas) + ':' + (onlyMinutos < 10 ? '0' + onlyMinutos : onlyMinutos) + ':' + (onlySegundos < 10 ? '0' + onlySegundos : onlySegundos);
    return newFormatData;
  }


  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getMondayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? -6 : 1);
    const monday = new Date(day.setDate(first));
    return monday;
  }

  getSundayOfCurrentWeek(dateNew) {
    const day = new Date(dateNew);
    const first = day.getDate() - day.getDay() + (day.getDay() === 0 ? 0 : 7);
    const sunday = new Date(day.setDate(first));
    return sunday;
  }

  addDays(date, days) {
    const copy = new Date(Number(date))
    copy.setDate(date.getDate() + days)
    return copy
  }

  formatoFecha(date) {
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    return `${day < 10 ? '0' + day : day}-${month < 10 ? '0' + month : month}-${year}`;
  }

  calculateWeeks(year, today?) {
    this.cmbWeeks = [];
    let firtsDateOfActualYear = new Date('01/01/' + year);
    let lastDateOfActualYear = new Date('12/31/' + year);
    for (let weeks = 1; firtsDateOfActualYear <= lastDateOfActualYear; weeks++) {
      let monday = this.getMondayOfCurrentWeek(firtsDateOfActualYear);
      let sunday = this.getSundayOfCurrentWeek(firtsDateOfActualYear);
      const payload = {
        id: weeks,
        descripcion: 'Semana ' + (weeks < 10 ? '0' + weeks : weeks) + ':   ' + this.formatoFecha(monday) + ' - ' + this.formatoFecha(sunday),
      };
      if (today && this.validateDate(firtsDateOfActualYear, today)) {
        this.actualWeek = weeks;
      }
      this.cmbWeeks.push(payload);
      firtsDateOfActualYear = this.addDays(firtsDateOfActualYear, 7);
    }
  }

  validateDate(firtDateF, secondDateF) {
    let firtDate = this.getMondayOfCurrentWeek(firtDateF);
    let secondDate = this.getMondayOfCurrentWeek(secondDateF);
    if ((firtDate.getDate() === secondDate.getDate()) && (firtDate.getFullYear() === secondDate.getFullYear()) && (firtDate.getMonth() === secondDate.getMonth())) {
      return true;
    } else {
      return false;
    }
  }

  calculateCombos() {
    const date = new Date();
    let year = date.getFullYear();
    this.cmbWeeks = [
      {
        id: 1,
        descripcion: 'Enero'
      },
      {
        id: 2,
        descripcion: 'Febrero'
      },
      {
        id: 3,
        descripcion: 'Marzo'
      },
      {
        id: 4,
        descripcion: 'Abril'
      },
      {
        id: 5,
        descripcion: 'Mayo'
      },
      {
        id: 6,
        descripcion: 'Junio'
      },
      {
        id: 7,
        descripcion: 'Julio'
      },
      {
        id: 8,
        descripcion: 'Agosto'
      },
      {
        id: 9,
        descripcion: 'Septiembre'
      },
      {
        id: 10,
        descripcion: 'Octubre'
      },
      {
        id: 11,
        descripcion: 'Noviembre'
      },
      {
        id: 12,
        descripcion: 'Diciembre'
      },
    ];
    this.cmbYears = [
      {
        id: year - 1,
        descripcion: year - 1
      },
      {
        id: year,
        descripcion: year
      },
      {
        id: year + 1,
        descripcion: year + 1
      }
    ];
  }

  selectCurrentDate() {
    const date = new Date();
    let year = date.getFullYear();
    this.formulario.get('year').setValue(year);
    this.formulario.get('week').setValue(date.getMonth() + 1);
    this.listAll();
  }

  getAllHorasExtra() {
    this.loading = true;
    const payload = this.formulario.value;
    this.subscription1$ = this._verificacionTalentoHumanoService.getAllSegundaVerificacion(payload).subscribe((res: any) => {
      let newDataArray = [];
      res.forEach(data => {
        let existingData = newDataArray.find(x => x.cedula === data.cedula);
        if (existingData) {
          existingData.horasExtrasTrabajadas = existingData.horasExtrasTrabajadas + data.horasExtrasTrabajadas;
          existingData.horasTrabajadas = existingData.horasTrabajadas + data.horasTrabajadas;
          existingData.percent_25 = existingData.percent_25 + data.percent_25;
          existingData.percent_50 = existingData.percent_50 + data.percent_50;
          existingData.percent_100 = existingData.percent_100 + data.percent_100;
          existingData.arrayId.push(data.id);
        } else {
          data.arrayId = [];
          data.arrayId.push(data.id);
          newDataArray.push(data);
        }
      });
      newDataArray.map(data => {
        data.statusP = data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA' ? 'APROBADO' : 'SIN APROBAR';
        data.check = (data.statusPrimeraAutorizacion && data.statusPrimeraAutorizacion !== 'NA') ? true : false;
        data.statusS = data.statusSegundaAutorizacion && data.statusSegundaAutorizacion !== 'NA' ? 'APROBADO' : 'SIN APROBAR';
        data.checkS = (data.statusSegundaAutorizacion && data.statusSegundaAutorizacion !== 'NA') ? true : false;
        data.newhorasExtrasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasExtrasTrabajadas);
        data.newhorasTrabajadas = this.formatoHorasNumeroToHorasFecha(data.horasTrabajadas);
        data.newpercent_25 = this.formatoHorasNumeroToHorasFecha(data.percent_25);
        data.newpercent_50 = this.formatoHorasNumeroToHorasFecha(data.percent_50);
        data.newpercent_100 = this.formatoHorasNumeroToHorasFecha(data.percent_100);
      });
      this.rowData = newDataArray;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.rowData = [];
    });
  }


  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
      //checkboxRenderer: CheckboxRenderer
    };

    this.columnDefs = [
      {
        headerName: 'CEDULA',
        field: 'cedula',
        sortable: true,
        filter: true,
        width: 120
      },
      {
        headerName: 'NOMBRE',
        field: 'nombre',
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'RECARGO NOC',
        field: 'newpercent_25',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'SUPLEMENTARIAS',
        field: 'newpercent_50',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'EXTRAORDINARIAS',
        field: 'newpercent_100',
        sortable: true,
        filter: true,
        width: 170
      },
      {
        headerName: 'TOTAL H-EXTRA',
        field: 'newhorasExtrasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'TOTAL H',
        field: 'newhorasTrabajadas',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ESTATUS PRIM',
        field: 'statusP',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'AUTORIZADOR PRIM',
        field: 'usuarioPrimeraAutorizacion',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'ESTATUS SEG',
        field: 'statusS',
        sortable: true,
        filter: true,
        width: 200,
        headerCheckboxSelection: true,
        checkboxSelection: (
          params: any
        ) => {
          return params.data && !params.data.checkS;
        },
      },
      {
        headerName: 'AUTORIZADOR SEG',
        field: 'usuarioSegundaAutorizacion',
        sortable: true,
        filter: true,
        width: 150
      },
    ];

    this.rowSelection = 'multiple';
  }

  onFirstDataRendered(params: any) {
    /*    params.api.forEachNode((node) =>
          node.setSelected(node.data && node.data.check)
        );*/
  }

  public isRowSelectable: any = (
    params: any
  ) => {
    return params.data && !params.data.checkS;
  };

  regresar() {
    this.formulario.reset();
    this.mostrarGridLista = true;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
  }

  listAll() {
    if (this.formulario.valid) {
      this.subscription1$ && this.subscription1$.unsubscribe();
      this.getAllHorasExtra();
    }
  }

  descargarExcel() {
    this.generarEcxel();
  }


  async generarEcxel() {
    this.dataExcel = [];
    this.workbook = new wb();
    this.rowData.forEach(x => {
      let payload = {
        cedula: x.cedula,
        nombre: x.nombre,
        horasExtrasTrabajadas: x.newhorasExtrasTrabajadas,
        horasTrabajadas: x.newhorasTrabajadas,
        rangoNocturno: x.newpercent_25,
        suplementaria: x.newpercent_50,
        extraordinario: x.newpercent_100,
      };
      this.dataExcel.push(payload);
    });
    this.fillExcelMarketplace();
    await this.workbook.xlsx.writeBuffer().then(data => {
      const blob = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      saveAs(blob, 'reporte-segunda/verificacion' + '.xlsx');
    });
  }


  fillExcelMarketplace() {
    const nameSheet = 'Talento Humano';
    let header;

    header = [
      'Cédula colaborador',
      'Colaborador',
      'Horas extra Trabajadas',
      'Horas Trabajadas',
      'Rango Nocturno',
      'Suplementaria',
      'Extraordinaria',
    ];
    let row;
    let headerRow;

    const worksheet = this.workbook.addWorksheet(nameSheet, {
      pageSetup: {
        horizontalCentered: true,
        verticalCentered: true,
        paperSize: 9,
        orientation: 'portrait',
        margins: {
          left: 0.3149606,
          right: 0.3149606,
          top: 0.3543307,
          bottom: 0.3543307,
          header: 0.3149606,
          footer: 0.3149606,
        },
      },
    });
    row = worksheet.getRow(0);
    headerRow = worksheet.addRow(header);
    headerRow.height = 25;

    worksheet.columns[0].width = 15;
    worksheet.columns[1].width = 40;
    worksheet.columns[2].width = 30;
    worksheet.columns[3].width = 10;
    worksheet.columns[4].width = 20;
    worksheet.columns[5].width = 20;
    worksheet.columns[6].width = 20;

    worksheet.eachRow(function (RowP, rowNum) {
      RowP.eachCell(function (Cell, cellNum) {
        Cell.alignment = {
          vertical: 'middle',
          horizontal: 'right',
        };
      });
    });

    this.data = this.formatData();

    this.fillRows(worksheet);

    this.formatWorksheet(worksheet, headerRow);
  }

  fillRows(worksheet: Worksheet) {
    for (const x1 of this.data) {
      const x2 = Object.keys(x1);
      const temp = [];
      for (const y of x2) {
        temp.push(x1[y]);
      }
      worksheet.addRow(temp);
    }
  }

  formatWorksheet(worksheet: Worksheet, headerRow: Row) {
    worksheet.eachRow(function (Rowt, rowNum) {
      Rowt.eachCell(function (cell, cellNum) {
        if (rowNum === headerRow.number) {
          cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: '1aa798'},
            bgColor: {argb: 'FF0000FF'},
          };
          cell.border = {
            top: {style: 'thin'},
            left: {style: 'thin'},
            bottom: {style: 'thin'},
            right: {style: 'thin'},
          };
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
          };
          cell.font = {
            bold: true,
          };
        } else {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'left',
          };
        }
      });
    });
  }

  formatData(n?: any) {
    this.data = [];
    switch (true) {
      default: {
        this.data = this.dataExcel;
        break;
      }
    }

    return this.data;
  }


  cargarAprobacion() {
    this.loading = true;
    let payload = [];
    this.gridApi.getSelectedRows().forEach(data => {
      if (data && data.arrayId) {
        payload = payload.concat(data.arrayId);
      }
    });
    this._verificacionTalentoHumanoService.procesarHorasExtrasSegundaVerificacion(payload).subscribe((res: any) => {
      this.loading = false;
      this.listAll();
    }, () => {
      this.loading = false;
      this.listAll();
    });
  }

}
